import { Cartesian } from "@examspark/types";

export const scoreShape = (
  expected: Cartesian.Shape,
  actual: Cartesian.Shape,
) => {
  if (actual.type !== expected.type) return;

  // console.log("scoring shape", expected, actual);

  switch (actual.type) {
    case "point":
      if (expected.type !== "point") return false;
      if (!coordsAreEqual(expected.coord, actual.coord)) return false;
      return true;
    case "ray-right":
      if (expected.type !== "ray-right") return false;
      if (!coordsAreEqual(expected.coord, actual.coord)) return false;
      return true;
    case "ray-left":
      if (expected.type !== "ray-left") return false;
      if (!coordsAreEqual(expected.coord, actual.coord)) return false;
      return true;
    case "ray-right-open":
      if (expected.type !== "ray-right-open") return false;
      if (!coordsAreEqual(expected.coord, actual.coord)) return false;
      return true;
    case "ray-left-open":
      if (expected.type !== "ray-left-open") return false;
      if (!coordsAreEqual(expected.coord, actual.coord)) return false;
      return true;
    case "line-segment":
      if (expected.type !== "line-segment") return false;
      if (!CoordsAreEqualPermutation(expected.coords, actual.coords))
        return false;
      return true;
    case "line-segment-both-open":
      if (expected.type !== "line-segment-both-open") return false;
      if (!CoordsAreEqualPermutation(expected.coords, actual.coords))
        return false;
      return true;
    case "line-segment-left-open":
      if (expected.type !== "line-segment-left-open") return false;
      if (!coordsAreEqual(expected.coords[0], actual.coords[0])) return false;
      if (!coordsAreEqual(expected.coords[1], actual.coords[1])) return false;
      return true;
    case "line-segment-right-open":
      if (expected.type !== "line-segment-right-open") return false;
      if (!coordsAreEqual(expected.coords[0], actual.coords[0])) return false;
      if (!coordsAreEqual(expected.coords[1], actual.coords[1])) return false;
      return true;
  }
};

export const coordsAreEqual = (
  coord1: Cartesian.CartesianCoordinate,
  coord2: Cartesian.CartesianCoordinate,
) => {
  if (coord1.x === coord2.x && coord1.y === coord2.y) return true;
  return false;
};

const CoordsAreEqualPermutation = (
  coords1: Cartesian.Coordinate[],
  coords2: Cartesian.Coordinate[],
) => {
  // this only works for length=2
  if (coords1.length !== 2) return false;
  return (
    (coordsAreEqual(coords1[0], coords2[0]) &&
      coordsAreEqual(coords1[1], coords2[1])) ||
    (coordsAreEqual(coords1[0], coords2[1]) &&
      coordsAreEqual(coords1[1], coords2[0]))
  );
};
